/*
 * Goat Milk Formula Quiz — goat-quiz.js
 * Upload: Shopify Admin → Themes → Edit code → Assets → goat-quiz.js
 * Connect: In templates/article.liquid:
 *   <script src="{{ 'goat-quiz.js' | asset_url }}" defer></script>
 *
 * NOTE: No inline onclick used — Shopify strips those from blog posts.
 * All events bound via addEventListener in this file.
 */

(function () {
  'use strict';

  var root = document.getElementById('gq-root');
  if (!root) return;

  var answers = {};
  var currentQ = 0;

  var questions = [
    {
      id: 'symptoms',
      text: "What symptoms is your baby experiencing?",
      help: 'Select the primary symptom. If multiple, pick the most severe.',
      options: [
        { label: 'Mild gas, fussiness, or occasional hard stools', desc: 'No skin rash, no blood in stool, no vomiting', value: 'mild_digestive' },
        { label: 'Frequent spit-up or reflux after feeds', desc: 'Formula comes back up within 30 minutes of feeding', value: 'reflux' },
        { label: 'Eczema, persistent skin rash, or hives', desc: 'Red, itchy patches on face, neck, or body', value: 'skin' },
        { label: 'Blood or mucus in stool', desc: 'Visible blood streaks or mucus in diaper', value: 'blood_stool' },
        { label: 'No symptoms \u2014 exploring options preventively', desc: 'Baby is doing fine, just researching alternatives', value: 'none' }
      ]
    },
    {
      id: 'diagnosis',
      text: 'Has your pediatrician diagnosed a specific condition?',
      help: 'Select the closest match.',
      options: [
        { label: 'No diagnosis \u2014 self-researching', value: 'no_diagnosis' },
        { label: "Cow's milk protein allergy (CMPA)", desc: 'Confirmed by pediatrician or allergist', value: 'cmpa' },
        { label: 'Lactose intolerance', desc: 'Confirmed inability to digest lactose', value: 'lactose_intolerance' },
        { label: 'Mild cow milk sensitivity (not allergy)', desc: 'Doctor said "sensitive" but not allergic', value: 'sensitivity' },
        { label: 'Colic / general digestive discomfort', desc: 'Crying 3+ hours/day, doctor says colic', value: 'colic' }
      ]
    },
    {
      id: 'current_formula',
      text: 'What is your baby currently drinking?',
      help: "This helps us understand what has or hasn't worked.",
      options: [
        { label: 'Standard cow milk formula (Similac, Enfamil, HiPP, Holle)', value: 'standard_cow' },
        { label: 'Comfort / sensitive formula (HiPP Comfort, Similac Sensitive)', value: 'comfort' },
        { label: 'Hypoallergenic formula (Nutramigen, Alimentum, HiPP HA)', value: 'ha' },
        { label: 'Breast milk (exclusively or mixed)', value: 'breastmilk' },
        { label: 'Not yet started \u2014 first formula choice', value: 'first_time' }
      ]
    },
    {
      id: 'family_history',
      text: 'Does either parent have allergies, eczema, or asthma?',
      help: 'Family history increases CMPA risk in infants.',
      options: [
        { label: 'Yes \u2014 one or both parents', value: 'yes' },
        { label: 'No known family history', value: 'no' },
        { label: 'Not sure', value: 'unsure' }
      ]
    },
    {
      id: 'priority',
      text: 'What matters most to you in a formula?',
      help: 'Your top priority helps narrow the recommendation.',
      options: [
        { label: 'Gentle on stomach \u2014 easiest to digest', value: 'gentle' },
        { label: 'Organic / clean ingredients', value: 'organic' },
        { label: 'Best value for money', value: 'budget' },
        { label: 'Closest to breast milk', value: 'breastmilk_like' }
      ]
    }
  ];

  var products = {
    holle_goat_1:    { name: 'Holle Goat Stage 1', detail: 'Demeter organic \u00b7 A2 goat \u00b7 Palm oil-free', price: '$28.30', url: '/products/holle-goat-stage-1' },
    holle_goat_dutch:{ name: 'Holle Goat Dutch Stage 1', detail: 'Demeter organic \u00b7 800g \u00b7 Premium goat', price: '$53.57', url: '/products/holle-dutch-formula' },
    hipp_goat:       { name: 'HiPP Dutch Goat Stage 1', detail: 'EU Organic \u00b7 Prebiotics \u00b7 No starch', price: '$36.85', url: '/products/hipp-dutch-goat-stage-1-formula' },
    kendamil_goat:   { name: 'Kendamil Goat Stage 1', detail: 'Whole goat milk \u00b7 MFGM \u00b7 Algae DHA', price: '$45.80', url: '/products/kendamil-goat-formula' },
    nannycare:       { name: 'Nannycare Stage 1', detail: 'New Zealand goat milk \u00b7 Gentle', price: '$36.50', url: '/collections/nannycare-baby-formula' },
    hipp_comfort:    { name: 'HiPP Comfort', detail: 'Reduced lactose \u00b7 Hydrolyzed protein \u00b7 Prebiotics', price: '$34.00', url: '/products/hipp-comfort' },
    hipp_ar:         { name: 'HiPP Anti-Reflux', detail: 'Locust bean gum \u00b7 Thickens in stomach', price: '$34.00', url: '/products/hipp-anti-reflux-formula' },
    hipp_ha:         { name: 'HiPP HA Stage 1', detail: 'Partially hydrolyzed \u00b7 Probiotics \u00b7 Prevention', price: '$34.95', url: '/products/hipp-ha-stage-1' },
    aptamil_pepti:   { name: 'Aptamil Pepti Stage 1', detail: 'Extensively hydrolyzed \u00b7 For diagnosed CMPA', price: '$37.80', url: '/products/aptamil-pepti-1' },
    holle_a2:        { name: 'Holle A2 Stage 1', detail: 'A2 cow milk \u00b7 Demeter \u00b7 Gentle digestion', price: '$28.30', url: '/products/holle-a2-stage-1' }
  };

  function getResult() {
    var s = answers.symptoms;
    var d = answers.diagnosis;
    var f = answers.family_history;
    var p = answers.priority;

    if (d === 'cmpa' || s === 'blood_stool') {
      return {
        icon: '\ud83d\udee1\ufe0f',
        title: 'Goat Milk Is NOT Right for Your Baby',
        body: '<p><strong>Important:</strong> Your baby has diagnosed or suspected CMPA (cow\'s milk protein allergy). Goat milk proteins cross-react with cow milk proteins in over 90% of CMPA cases \u2014 goat formula will likely trigger the same allergic reaction.</p><p>Your baby needs a <strong>hydrolyzed formula</strong> where the proteins are broken down small enough that the immune system doesn\'t recognize them.</p>',
        recs: ['aptamil_pepti', 'hipp_ha'],
        warn: 'This quiz does not replace medical advice. If your baby has blood in stool, persistent eczema, or respiratory symptoms, contact your pediatrician immediately.'
      };
    }

    if (d === 'lactose_intolerance') {
      return {
        icon: '\u26a0\ufe0f',
        title: 'Goat Milk Is NOT Ideal for Lactose Intolerance',
        body: '<p>All goat milk formulas contain lactose \u2014 approximately the same amount as cow milk formulas. Goat milk has ~10\u201315% less lactose, but this is not clinically significant for true lactose intolerance.</p><p>For confirmed lactose intolerance, your baby needs a <strong>reduced-lactose or lactose-free formula</strong>. HiPP Comfort reduces lactose by ~60%.</p>',
        recs: ['hipp_comfort'],
        warn: 'True lactose intolerance is extremely rare in infants under 12 months. Most cases are temporary lactase deficiency after gastroenteritis or cow milk protein sensitivity. Consult your pediatrician for proper diagnosis.'
      };
    }

    if (s === 'reflux') {
      return {
        icon: '\ud83e\udd22',
        title: 'Consider Anti-Reflux Formula Before Goat',
        body: '<p>For reflux and frequent spit-up, an <strong>anti-reflux formula</strong> is more targeted than goat milk. HiPP Anti-Reflux contains locust bean gum \u2014 a natural thickener that stays liquid in the bottle but thickens in the stomach, keeping feeds down.</p><p>If reflux resolves but other digestive issues remain, goat milk could be a good next step.</p>',
        recs: ['hipp_ar', 'hipp_goat'],
        warn: 'If your baby arches away from the bottle, has unexplained weight loss, or chokes during feeds, consult your pediatrician \u2014 this may indicate GERD.'
      };
    }

    if (s === 'skin') {
      return {
        icon: '\ud83d\udd0d',
        title: 'See Your Pediatrician Before Trying Goat',
        body: '<p>Eczema and skin rashes after feeding can indicate <strong>CMPA</strong> \u2014 not just sensitivity. Goat milk proteins cross-react with cow milk in 90%+ of CMPA cases.</p><p>Ask your pediatrician to evaluate before switching. If confirmed as mild sensitivity (not allergy), then goat milk may help.</p>',
        recs: ['hipp_ha', 'aptamil_pepti', 'hipp_goat'],
        warn: 'Skin symptoms + feeding issues warrant a pediatrician visit. The treatment for CMPA (hydrolyzed formula) is very different from treatment for sensitivity (goat or comfort formula).'
      };
    }

    if (d === 'colic') {
      return {
        icon: '\ud83d\ude0c',
        title: 'Goat Milk May Help \u2014 But Consider Comfort First',
        body: '<p>For diagnosed colic, <strong>HiPP Comfort</strong> is specifically designed with reduced lactose, hydrolyzed protein, and beta-palmitate fats. It attacks colic from three angles.</p><p>If Comfort doesn\'t fully resolve symptoms after 2 weeks, goat milk is a reasonable next step.</p>',
        recs: ['hipp_comfort', 'hipp_goat', 'holle_goat_1'],
        warn: ''
      };
    }

    // YES — goat is right
    var recList;
    if (p === 'budget') {
      recList = ['holle_goat_1', 'holle_a2', 'hipp_goat'];
    } else if (p === 'organic') {
      recList = ['holle_goat_dutch', 'hipp_goat', 'holle_goat_1'];
    } else if (p === 'breastmilk_like') {
      recList = ['kendamil_goat', 'hipp_goat', 'nannycare'];
    } else {
      recList = ['hipp_goat', 'holle_goat_1', 'kendamil_goat'];
    }

    var title = s === 'none'
      ? 'Yes \u2014 Goat Milk Formula Is a Great Option!'
      : 'Yes \u2014 Goat Milk Formula Is a Good Fit!';

    var bodyText = s === 'none'
      ? '<p>Your baby has no specific symptoms \u2014 great news! Goat milk formula is an excellent choice. It contains naturally A2 beta-casein protein, forms softer curds, and has ~10\u201315% less lactose than cow milk.</p>'
      : '<p><strong>Good news:</strong> Your baby\'s symptoms are consistent with <strong>mild cow milk sensitivity</strong> \u2014 exactly what goat milk formula helps. A2 protein and softer curds improve digestion. Most parents see improvement within 5\u20137 days.</p>';

    var warnText = '';
    if (f === 'yes') {
      warnText = 'You indicated a family history of allergies. Monitor your baby closely on goat milk. If eczema, blood in stool, or respiratory symptoms develop, consult your pediatrician about hypoallergenic formula.';
    }

    return { icon: '\ud83d\udc10', title: title, body: bodyText, recs: recList, warn: warnText };
  }

  function renderRecCards(keys) {
    var html = '';
    for (var i = 0; i < keys.length; i++) {
      var p = products[keys[i]];
      if (!p) continue;
      html += '<a href="' + p.url + '" class="gq-rec-card">' +
        '<div><div class="gq-rec-name">' + p.name + '</div>' +
        '<div class="gq-rec-detail">' + p.detail + '</div></div>' +
        '<div class="gq-rec-price">' + p.price + '</div></a>';
    }
    return html;
  }

  function showScreen(id) {
    var all = root.querySelectorAll('.gq-screen');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('gq-active');
    document.getElementById(id).classList.add('gq-active');
  }

  function bindOptions() {
    var btns = root.querySelectorAll('.gq-opt');
    for (var j = 0; j < btns.length; j++) {
      btns[j].addEventListener('click', function () {
        var q = questions[currentQ];
        answers[q.id] = this.getAttribute('data-value');
        currentQ++;
        if (currentQ < questions.length) {
          renderQuestion();
        } else {
          showResult();
        }
      });
    }
  }

  function renderQuestion() {
    var q = questions[currentQ];
    document.getElementById('gq-q-num').textContent = 'Question ' + (currentQ + 1) + ' of ' + questions.length;
    document.getElementById('gq-q-text').textContent = q.text;
    document.getElementById('gq-q-help').textContent = q.help || '';
    document.getElementById('gq-progress-fill').style.width = ((currentQ + 1) / questions.length * 100) + '%';

    var html = '';
    for (var i = 0; i < q.options.length; i++) {
      var o = q.options[i];
      html += '<button class="gq-opt" data-value="' + o.value + '">' + o.label;
      if (o.desc) html += '<span class="gq-opt-desc">' + o.desc + '</span>';
      html += '</button>';
    }
    document.getElementById('gq-options').innerHTML = html;
    bindOptions();
    showScreen('gq-question');
  }

  function showResult() {
    var result = getResult();
    document.getElementById('gq-result-icon').textContent = result.icon;
    document.getElementById('gq-result-title').textContent = result.title;
    document.getElementById('gq-result-body').innerHTML = result.body;
    document.getElementById('gq-result-recs').innerHTML = renderRecCards(result.recs);

    var w = document.getElementById('gq-result-warn');
    if (result.warn) {
      w.innerHTML = '<strong>\u26a0\ufe0f Important:</strong> ' + result.warn;
      w.style.display = 'block';
    } else {
      w.style.display = 'none';
    }

    showScreen('gq-result');
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Bind Start button
  var startBtn = document.getElementById('gq-start-btn');
  if (startBtn) {
    startBtn.addEventListener('click', function () {
      currentQ = 0;
      answers = {};
      renderQuestion();
    });
  }

  // Bind Restart button
  var restartBtn = document.getElementById('gq-restart-btn');
  if (restartBtn) {
    restartBtn.addEventListener('click', function () {
      currentQ = 0;
      answers = {};
      showScreen('gq-intro');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

})();